export class Customer {
  id: number;
  FirstName: string;
  LastName: string;
  MiddleName: string;
  Email: string;
  dob: string;
  countryiso2: string;
  PhoneNumber: string;
  Device_Type: number;
  phoneCodeiso2: string;
  loggedin_Country: string;
  userType: 0 | 1;
  UserId: string;
  Password: string;
  user_Role_Code: number;
  userTypeStr?:string;
  userDetails?:string;
  assignFormObj(formObj) {
    Object.assign(this, formObj);
    return this;
  }
}

export class User extends Customer {
  token?: string;
}

export class Agent extends Customer {
  license?: string;
  address: Address;
  orgAddress?: Address;
  identityDocs?: any;
  organization?: Organization;
}

export class Address {
  street1?: string;
  street2?: string;
  country: string;
  state: string;
  city: string;
  zip: string;
}

export class Organization {
  name?: string;
  license: string;
  type?: "C" | "NC";
  logo?: string;
  description?: string;
  businessType?: string;
  noOfEmployees?: number;
}
